import { render, staticRenderFns } from "./reporthistoryview.vue?vue&type=template&id=31f7f133&scoped=true&"
import script from "./reporthistoryview.vue?vue&type=script&lang=js&"
export * from "./reporthistoryview.vue?vue&type=script&lang=js&"
import style0 from "./reporthistoryview.vue?vue&type=style&index=0&id=31f7f133&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f7f133",
  null
  
)

export default component.exports